<template>
    <nav v-if="loading" class="main-header__hamburger">
        <button class="hamburger" v-on:click="toggleActiveState">
            <!-- Open -->
            <Icon name="hamburger" />
        </button>
        
        <portal to="destination">
            <div class="nav-overlay">
                <div class="nav-overlay__inner">
                    <div class="nav-overlay__header">
                        <a v-bind:href="`${siteLink}`" class="nav-overlay__logo">
                            <img v-bind:src="`${themeUrl}/assets/images/jsconsultancy-logo-diap.svg`" alt="Logo JS Consultancy">
                        </a>
                        <button class="nav-overlay__close" v-on:click="toggleActiveState">
                            <!-- Open -->
                            <Icon name="close" />
                        </button>
                    </div>
                    <div class="nav-overlay__body">
                        <ul class="nav-overlay__list">
                            <nav-overlay-item 
                            v-for="menuitem in menu" 
                            :key="menuitem.ID"
                            :is-active="menuitem.title == store.activeSubmenu"
                            @click="handleClick({event: $event, data: menuitem})"
                            v-bind:item="menuitem"></nav-overlay-item>
                        </ul>
                        <div class="nav-overlay__contact">
                            <slot name="contact"></slot>
                        </div>
                        <div class="nav-overlay__actions">
                            <a :href="contact.url" class="nav-overlay__btn btn btn--b">{{ contact.title }}</a>
                            <a :href="login.url" target="_blank" class="nav-overlay__btn btn btn--c btn--has-icon">
                                <span class="btn__icon btn__icon--left">
                                    <Icon name="user" color="#fff" />
                                </span>
                                <span class="button__text">Inloggen</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </portal>
    </nav>
</template>

<script>
import NavOverlayItem from './NavOverlayItem.vue';
import Icon from './Icon.vue';
import _ from 'lodash';
import { store } from './store.js'

export default {
    name: 'NavOverlay',
    data() {
        return {
            loading: false,
            active: false,
            menu: [],
            topbar: [],
            siteLink: window.site_link,
            themeUrl: window.theme_url,
            store,
            login: null,
            contact: null,
            isDesktop: false
        };
    },
    watch: {
        'store.activeSubmenu': function() {
            if(!this.active && store.activeSubmenu) {
                this.active = true;
                document.getElementsByTagName("html")[0].classList.add('js-state-hamburger-open');
            }
        }
    },
    props: ['menuitems', 'actions'],
    methods: {
        toggleActiveState() {
            this.active = !this.active;
            if(this.active) {
                document.getElementsByTagName("html")[0].classList.add('js-state-hamburger-open');

                // set active submenu to the first child of our menu, this only works if the first child has children
                if(this.isDesktop) {
                    this.store.activeSubmenu = this.menu[0].title;
                }
            } else {
                document.getElementsByTagName("html")[0].classList.remove('js-state-hamburger-open');
                store.activeSubmenu = null;
            }
        },
        handleClick(event) {
            if(store.activeSubmenu === event.data.title) {
                store.activeSubmenu = null;
            } else {
                store.activeSubmenu = event.data.title;
            }
        }
    },
    mounted: function() {
        const mediaQuery = window.matchMedia('(min-width: 1024px)');
        const actions = JSON.parse(this.actions);

        if(this.menuitems) {
            const menuitems = JSON.parse(this.menuitems);
            this.menu = _.sortBy(menuitems, 'order');
        }
        this.isDesktop = mediaQuery.matches;
        
        this.login = actions['login'];
        this.contact = actions['contact'];

        this.loading = true;
    },
    components: {
        NavOverlayItem: NavOverlayItem,
        Icon: Icon
    },
};
</script>